export default __webpack_public_path__ + "static/media/Josh Hoover.78e09964.jpg";